import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { firstMap } from "keautils";
import { SelectQueryProps, SelectQueryViewProps, SelectQueryViewPropsRx } from "kea-react/dist/selector/query";
import { observeResource } from "kea-resource";
import { validarIdentificacion } from "app/logic/cliente";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";
import { FiltroCliente, FiltroRep } from "app/models/requireme";



export class RepItem extends React.PureComponent<{ value: models.RepDTO }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <span>
                    <label>{x.SerieFolio}</label>
                </span>
                <br />
                {
                    <span>
                        <b>{kea.formatCurrency(x.ImportePagado)}</b>
                    </span>
                }
            </div>
        )
    }
}

function mapSelectItem(x: models.RepDTO): kea.SelectorElement {
    return {
        value: x.IdRegistro,
        label: x.SerieFolio,
        view: <RepItem value={x} />
    }
}

export interface SelectorRepProps extends SelectQueryViewPropsRx {
    /**Filtro extra para el selector de clientes */
    filtro?: FiltroRep;
}

export class Rep extends React.PureComponent<SelectorRepProps> {
    modalManager = kea.createModalManager();

    filtro = (props: SelectorRepProps) => props.filtro || {};
    readOnly = (props: SelectorRepProps) => props.readonly;

    loadItems = createSelectorRx(this.filtro,
        filtro => kea.loadSelectorItemsFuncFromResource(busqueda => observeResource(resources.Rep.Query, {
            SerieFolio: busqueda,
            Limite: 50,
            ...filtro,
        }), id => observeResource(resources.Rep.Get, id), mapSelectItem)
    )


    render() {
        const loadItemsFunc = this.loadItems(this.props);
        return (
            <div>
                <kea.SelectQuery label="Rep" loadItems={loadItemsFunc} {... this.props} />
                {this.modalManager.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/rep.tsx